import { RingProgress } from "@mantine/core";

export default {
  RingProgress: RingProgress.extend({
    defaultProps: {
      thickness: 6,
      roundCaps: true,
    },
  }),
};
